module.exports = __webpack_public_path__ + "img/uniliver(2) 1.d20a62e.svg";